// @ts-nocheck
/* eslint-disable */

"use client";

import {
  Button,
  Column,
  Heading,
  Icon,
  RichText,
  Row,
  ShareModal,
  Spacer,
} from "tempdev-ds";
import { useEffect, useState } from "react";

import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import GravityForm from "@/components/common/GravityForm/GravityForm";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import { removeScroll } from "@/lib/helpers/removeScroll";
import { styled } from "styled-components";
import { useGlobalContext } from "@/lib/globalContext";

const StyledPost = styled.div`
  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    margin-bottom: 1.4rem;
  }
  ul {
    padding: 0;
    list-style: none;

    & li {
      position: relative;
      padding-left: 2rem;
      margin-top: 1rem;

      &:first-child {
        margin-top: 0;
      }

      &:before {
        content: "\\e910";
        speak: none;
        font-feature-settings: normal;
        font-family: miewfont !important;
        font-style: normal;
        font-variant: normal;
        font-weight: 400;
        line-height: 1;
        text-transform: none;

        position: absolute;
        top: 8px;
        left: 0;
        font-size: 1rem;
      }
    }
  }
`;

const CareersPost = (post: Record<string, unknown>) => {
  const state = useGlobalContext();
  const [shareOpen, setShareOpen] = useState(false);

  useEffect(() => {
    removeScroll(shareOpen, state);
  }, [shareOpen]);

  return (
    <div>
      <Spacer height={6} />
      <Row>
        <Column md={8}>
          <Button
            variant="link"
            href="/hiring/"
            rightIcon={<Icon icon="icon-arrow-link"></Icon>}
          >
            {state?.dict?.custom?.viewJobs}
          </Button>
          <Heading size="h1" tag="h1">
            {post.title}
          </Heading>
          <RichText tag="p" className="mt-3">
            {post.excerpt}
          </RichText>
          <Spacer height={8} />
          <StyledPost>
            {!!(post?.blocks as [])?.length &&
              (post?.blocks as []).map((block: BlocksProps, index: number) => {
                return displayBlock(block, index);
              })}
          </StyledPost>
        </Column>
        <Column md={1}></Column>
        <Column md={3}>
          <div className="sticky-element" style={{ top: "6rem" }}>
            <div
              className="share-holder radius-md radius-md-lg shadow-sm p-4 text-center"
              style={{
                backgroundColor: "#EEFCFB",
              }}
            >
              <Heading tag="h3" size="h5">
                {state?.dict?.custom?.interested}
              </Heading>
              <RichText tag="p" className="mt-3">
                {state?.dict?.custom?.careersTitle}
              </RichText>
              <div className="d-flex align-items-center justify-content-center mt-3">
                <Button
                  variant={"primary"}
                  href={"#page-form"}
                  className="mt-3"
                  style={{ minWidth: "unset" }}
                >
                  {state?.dict?.custom?.apply}
                </Button>

                <Button
                  variant={"link"}
                  leftIcon={<Icon icon="icon-share" />}
                  className="mt-3"
                  onClick={() => setShareOpen(true)}
                >
                  {state?.dict?.blog?.shareBtn}
                </Button>
              </div>
            </div>
          </div>
        </Column>
      </Row>
      {post?.form && (
        <div id="page-form">
          <Row>
            <Column md={12}>
              <Spacer height={8} />
              <div
                className="rounded-section"
                style={{ color: "#343A46", backgroundColor: "#EEF9FC" }}
              >
                <Heading
                  tag="h6"
                  size="texts"
                  className="color-gray50 text-uppercase"
                >
                  {state?.dict?.custom?.interested}
                </Heading>
                <Heading tag="h3" size="h2" className="mb-5">
                  {state?.dict?.custom?.applyJob}
                </Heading>

                <GravityForm formData={post?.form} formId={process.env.NEXT_PUBLIC_HIRING_FORM_ID} />
              </div>
            </Column>
          </Row>
        </div>
      )}
      <Spacer height={8} />
      <ShareModal
        siteTitle={process.env.NEXT_PUBLIC_SITE_NAME}
        title={post.title}
        url={`${process.env.NEXT_PUBLIC_FE_URL}${post.slug}`}
        label={(state?.dict?.blog as Record<string, string>)?.shareBtn}
        copyText={(state?.dict?.blog as Record<string, string>)?.shareCopy}
        open={shareOpen}
        onClose={() => setShareOpen(false)}
      ></ShareModal>
    </div>
  );
};
export default CareersPost;
